/**
 * Offline notification queue helpers.
 *
 * Pure logic for AuthenticatedLayout's replay of queued `/api/notifications/send`
 * requests, extracted so it can be tested without React.
 */

/** Client errors that are transient, so a later replay can still succeed. */
const RETRYABLE_CLIENT_ERRORS = new Set([408, 429]);

/**
 * Whether a replayed queued notification should leave the queue.
 *
 * Success drops it; so does a 4xx — the backend rejected it on validation or
 * permissions, and replaying it can never succeed (same rule as
 * useNotificationCreator's sendWithRetry) — except the transient 408/429.
 * 5xx keeps it queued for the next `online` event.
 */
export function shouldDropQueuedNotification(status: number): boolean {
  if (status >= 200 && status < 300) return true;
  return status >= 400 && status < 500 && !RETRYABLE_CLIENT_ERRORS.has(status);
}
